const ZIndexLayers = {
  default: 0, // Default value
  elevateOne: 1, // Used to elevate a component/view by 1.
  overlay: 10, // Used to add some overlay/decoration to an element.
  immediatelyAboveOverlay: 11, // Used to elevate a component/view immediately above a fixed element
  actions: 100, // Floating actions layer
  immediatelyAboveFirstAvatar: 301, // ONLY used to elevate a second avatar immediately above an avatar.
  immediatelyAboveAllAvatars: 302, // This MUST be used when elevating any other component above avatars.
  immediatelyBelowNavbar: 9939, // Used to elevate a component/view immediately below the navbar
  navbar: 9940, // Navbar layer for app header and mobile bottom navigation
  drawer: 9950, // Nav drawer layer for desktop
  fixedElement: 9960, // Fixed page elements layer
  immediatelyAboveFixedElement: 9961, // Used to elevate a component/view immediately above a fixed element
  fullScreenOverlay: 9970, // Fullscreen overlay views layer
  popup: 9980, // Used for popups withing the app
  backdrop: 9990, // Modal & Bottomsheet backdrops layer
  modal: 9999, // Modal & Bottomsheet window layers. This value equals --nextui-zIndices-max
  tooltip: 9999, // Tooltips
  overModal: 10000, // Used to elevate a component/view over a modal
  vinScanner: 10010, // Used to elevate the vin scanner
  vinScannerCloseButton: 10011, // Used to elevate the close button of the vin scanner
};

export default ZIndexLayers;
